import {Injectable} from '@angular/core';
import {PermissionArea} from '../enums/permission-area.enum';
import {AuthState} from '../state/auth/auth.state';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';

@Injectable()
export class AclService {
    @SelectSnapshot(AuthState.permissions) permissions: PermissionArea[];

    checkAcl(requiredPermission: string | PermissionArea) {
        const permissionArea = requiredPermission as PermissionArea;
        // check for MANAGEMENT access
        if (permissionArea === PermissionArea.MANAGEMENT) {
            return this.permissions?.some(permission =>
                permission.toString().endsWith(PermissionArea.MANAGEMENT.toString())
                || permission.toString().endsWith(PermissionArea.CONFIGURATION.toString())
            );
        }
        // check for CONFIGURATION access
        else if (permissionArea === PermissionArea.CONFIGURATION) {
            return this.permissions?.some(permission => permission.toString().endsWith(permissionArea.toString()));
        }
        // check for PRODUCT_MANAGEMENT access
        else if (permissionArea === PermissionArea.PRODUCT_MANAGEMENT) {
            return this.permissions?.some(permission =>
                [PermissionArea.PRODUCT_CPI_MANAGEMENT, PermissionArea.PRODUCT_UPG_MANAGEMENT].includes(permission)
            );
        }
        // case when user can manage localizations only on own partner
        if (permissionArea === PermissionArea.LOCALIZATION_MANAGEMENT_LIMITED) {
            return this.permissions?.includes(PermissionArea.LOCALIZATION_MANAGEMENT)
                && !this.permissions?.includes(PermissionArea.PARTNER_MANAGEMENT);
        }
        return requiredPermission
            ? this.permissions?.includes(permissionArea)
            : true;
    }
}
